// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-sp-advanced-criteria-popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background-color: var(--row-light);
}

.fund-sp-advanced-criteria-popup-inner {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.fund-sp-advanced-criteria-popup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 50px;
  padding: 16px;
  position: relative;
  border-bottom: 1px solid var(--border-secondary);
}

.fund-sp-advanced-criteria-popup-back {
  left: 16px;
}

.fund-sp-advanced-criteria-popup-back svg {
  width: 24px;
  height: 24px;
}

.fund-sp-advanced-criteria-popup-title {
  color: var(--text-subheader);
  text-align: center;
}

.fund-sp-criteria-screen {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.fund-sp-criteria-screen-scroll {
  flex: 1;
  min-height: 0;
  padding: 0 24px 16px;
  overflow-y: auto;
}

.fund-sp-criteria-field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px 0;
}

.fund-sp-criteria-field-title {
  color: var(--text-subheader);
  text-align: left;
}

.fund-sp-criteria-field-dropdown {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  margin: 0;
  padding: 6px 16px;
  border: 1px solid var(--border-input);
  border-radius: 4px;
  background-color: var(--row-light);
  font: inherit;
  cursor: pointer;
  &:hover {
    border: 1px solid var(--border-primary-brand);
  }
}

.fund-sp-criteria-field-dropdown-value {
  flex: 1;
  text-align: left;
  color: var(--input-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fund-sp-criteria-field-dropdown-arrow {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.fund-sp-criteria-add-button-wrapper {
  box-sizing: border-box;
  padding: 16px 24px;
  height: 75px;
  margin-top: auto;
}

.fund-sp-criteria-add-button {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  text-transform: none;
  &:hover {
    background: var(--color-brand-hover2);
  }
}

.fund-sp-criteria-footer {
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid var(--border-tertiary);
}

.fund-sp-criteria-primary-button {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  text-transform: none;
  &:hover {
    opacity: 0.9;
  }
}

.fund-sp-criteria-text-button {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  text-transform: none;
  &:hover {
    background: var(--color-brand-hover2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/Criteria/FundSPAdvancedCriteriaPopup/FundSPAdvancedCriteriaPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB;IACE,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".fund-sp-advanced-criteria-popup {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  background-color: var(--row-light);\n}\n\n.fund-sp-advanced-criteria-popup-inner {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n.fund-sp-advanced-criteria-popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  height: 50px;\n  padding: 16px;\n  position: relative;\n  border-bottom: 1px solid var(--border-secondary);\n}\n\n.fund-sp-advanced-criteria-popup-back {\n  left: 16px;\n}\n\n.fund-sp-advanced-criteria-popup-back svg {\n  width: 24px;\n  height: 24px;\n}\n\n.fund-sp-advanced-criteria-popup-title {\n  color: var(--text-subheader);\n  text-align: center;\n}\n\n.fund-sp-criteria-screen {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n.fund-sp-criteria-screen-scroll {\n  flex: 1;\n  min-height: 0;\n  padding: 0 24px 16px;\n  overflow-y: auto;\n}\n\n.fund-sp-criteria-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  padding: 16px 0;\n}\n\n.fund-sp-criteria-field-title {\n  color: var(--text-subheader);\n  text-align: left;\n}\n\n.fund-sp-criteria-field-dropdown {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 40px;\n  margin: 0;\n  padding: 6px 16px;\n  border: 1px solid var(--border-input);\n  border-radius: 4px;\n  background-color: var(--row-light);\n  font: inherit;\n  cursor: pointer;\n  &:hover {\n    border: 1px solid var(--border-primary-brand);\n  }\n}\n\n.fund-sp-criteria-field-dropdown-value {\n  flex: 1;\n  text-align: left;\n  color: var(--input-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fund-sp-criteria-field-dropdown-arrow {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.fund-sp-criteria-add-button-wrapper {\n  box-sizing: border-box;\n  padding: 16px 24px;\n  height: 75px;\n  margin-top: auto;\n}\n\n.fund-sp-criteria-add-button {\n  box-sizing: border-box;\n  width: 100%;\n  height: 48px;\n  text-transform: none;\n  &:hover {\n    background: var(--color-brand-hover2);\n  }\n}\n\n.fund-sp-criteria-footer {\n  box-sizing: border-box;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border-top: 1px solid var(--border-tertiary);\n}\n\n.fund-sp-criteria-primary-button {\n  box-sizing: border-box;\n  width: 100%;\n  height: 48px;\n  text-transform: none;\n  &:hover {\n    opacity: 0.9;\n  }\n}\n\n.fund-sp-criteria-text-button {\n  box-sizing: border-box;\n  width: 100%;\n  height: 48px;\n  text-transform: none;\n  &:hover {\n    background: var(--color-brand-hover2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
